import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-ocr-document-validator',
  templateUrl: './ocr-document-validator.component.html',
  styleUrls: ['./ocr-document-validator.component.css']
})
export class OcrDocumentValidatorComponent implements OnInit {

  @Input() data: any;
  @Input() docType: string;
  @Output() validationFormSubmitted = new EventEmitter();

  validationForm: FormGroup;
  constructor(private fb: FormBuilder) { }

  ngOnInit() {
    this.initForm();
    this.validationForm.patchValue(this.data);
  }

  initForm() {
    this.validationForm = this.fb.group({
      'number': ['', Validators.required],
      'name': [''],
      'dob': [null, Validators.required],
      'guardian_name': [''],
      'issue_date': [''],
      'full_address': [''],
      'expiry_date': ['']

    });
  }

  submitForm() {
    this.validationFormSubmitted.emit(this.validationForm.value);
  }

}



// WEBPACK FOOTER //
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/src/app/ocr/ocr-document-validator/ocr-document-validator.component.ts